// SPDX-License-Identifier: AGPL-3.0-or-later

import type {GatewayHandlerContext} from '@app/features/gateway/events/EventRouter';
import KonvoCalendarPrefs from '@app/features/konvo_calendar/state/KonvoCalendarPrefs';

export function handleKonvoPrefsUpdate(data: unknown, _context: GatewayHandlerContext): void {
	if (!data || typeof data !== 'object') return;
	KonvoCalendarPrefs.applyRemote(data as Parameters<typeof KonvoCalendarPrefs.applyRemote>[0]);
}
